@if (modoAtual() === 'detalhes') {
  <div class="menu-reacao menu-reacao-detalhes" role="dialog" aria-label="Reações da mensagem">
    <span class="menu-reacao-titulo">1 reação</span>
    <div class="menu-reacao-abas">
      @if (podeReagir) {
        <button type="button" class="menu-reacao-btn-adicionar" aria-label="Escolher outra reação" (click)="abrirSeletor()">
          <span class="chat-icone-duplo"><img src="./assets/icones/redesign/modulos/chat/components-message/reaction.svg" alt="" class="chat-icone-base" /><img src="./assets/icones/redesign/modulos/chat/components-message/reaction-primary.svg" alt="" class="chat-icone-ativo" /></span>
        </button>
      }
      <span class="menu-reacao-aba-ativa">{{ mensagem.reacao }} 1</span>
    </div>
    <button type="button" class="menu-reacao-autor" [class.menu-reacao-autor-removivel]="reacaoEhMinha" [disabled]="!reacaoEhMinha"
            (click)="clicarAutor()">
      @if (fotoAutor && !fotoComErro()) {
        <img class="menu-reacao-avatar" [src]="fotoAutor" alt="" (error)="fotoComErro.set(true)" />
      } @else {
        <span class="menu-reacao-avatar menu-reacao-avatar-inicial">{{ inicialAutor }}</span>
      }
      <span class="menu-reacao-autor-textos">
        <span class="menu-reacao-autor-nome">{{ nomeAutor }}</span>
        @if (reacaoEhMinha) {
          <span class="menu-reacao-autor-dica">Clique para remover</span>
        }
      </span>
      <span class="menu-reacao-autor-emoji">{{ mensagem.reacao }}</span>
    </button>
  </div>
} @else {
  <div class="menu-reacao menu-reacao-seletor" role="menu" aria-label="Reagir à mensagem">
    <div class="menu-reacao-rapidas">
      @for (emoji of reacoesRapidas; track emoji) {
        <button type="button" class="menu-reacao-rapida" [class.menu-reacao-rapida-ativa]="mensagem.reacao === emoji" role="menuitem"
                [attr.aria-label]="'Reagir com ' + emoji" (click)="escolherRapida(emoji)">{{ emoji }}</button>
      }
      <button type="button" class="menu-reacao-mais" [class.menu-reacao-mais-ativo]="seletorCompleto()" aria-label="Mais emojis"
              (click)="seletorCompleto.set(!seletorCompleto())">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </button>
    </div>
    @if (seletorCompleto()) {
      <div class="menu-reacao-completo" @expandir>
        <emoji-mart
          [isNative]="true"
          [darkMode]="false"
          [showPreview]="false"
          [enableSearch]="true"
          [perLine]="8"
          [emojiSize]="24"
          [color]="'#993DF5'"
          [i18n]="i18nEmoji"
          [emojiTooltip]="false"
          (emojiSelect)="escolherCompleto($event)"
        ></emoji-mart>
      </div>
    }
  </div>
}
